var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HomeworkList',{staticClass:"member-homework",on:{"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }